'use client';

import React, { FC } from 'react';
import { useInView } from 'react-intersection-observer';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import AdvantageList from '@/src/components/sections/advantageList/AdvantageList';
import Label from '@/src/components/ui/label/Label';
import DemoCard from '@/src/components/ui/demoCard/DemoCard';
import { advFeaturesFull } from '@/src/lib/staticObjects/advInfo';
import createAnimationArr from '@/src/lib/helpers/createAnimationArr';

import SearchInHero from '@/src/components/screens/stockistTheme/searchInHero/SearchInHero';
import NavSection from '@/src/components/screens/stockistTheme/navSection/NavSection';
import SearchSection from '@/src/components/screens/stockistTheme/searchSection/SearchSection';
import UniqueSection from '@/src/components/screens/stockistTheme/uniqueSection/UniqueSection';
import SaleSection from '@/src/components/screens/stockistTheme/saleSection/SaleSection';
import ProductPage from '@/src/components/screens/stockistTheme/productPage/ProductPage';
import CatalogSection from '@/src/components/screens/stockistTheme/catalogSection/CatalogSection';
import OtherSection from '@/src/components/screens/stockistTheme/otherSection/OtherSection';
import BlogSection from '@/src/components/screens/stockistTheme/blogSection/BlogSection';
import CtaBanner from '@/src/components/screens/stockistTheme/ctaBanner/CtaBanner';
import DemoBanner from '@/src/components/screens/stockistTheme/demoBanner/DemoBanner';

import styles from './Theme.module.scss';
import { ITheme } from '@/src/lib/types/themeInterface';
import HelpSection from '@/src/components/sections/helpSection/HelpSection';
import SubscribeSection from '@/src/components/sections/subscribeSection/SubscribeSection';

type TThemeStockist = {
  theme: ITheme;
};

const ThemeStockist: FC<TThemeStockist> = ({ theme }) => {
  const { ref: inViewRef1, inView: inView1 } = useInView({
    triggerOnce: true,
    rootMargin: `-250px 0px 0px`,
    threshold: 0,
  });

  return (
    <>
      <Wrapper>
        <AdvantageList advList={advFeaturesFull} middle />
      </Wrapper>
      <section ref={inViewRef1} className={styles.demos}>
        <Wrapper className={styles.demosStockist}>
          <Label>Starter Sites</Label>

          <h2 className={`heading__2 ${styles.heading} ${inView1 && styles.animate__heading}`}>
            {theme.demoSectionTitle &&
              createAnimationArr(theme.demoSectionTitle, styles.word__wrapper, 0, 0.01)}
          </h2>

          <p className={`excerpt ${styles.excerpt} ${inView1 && styles.animate__excerpt}`}>
            {theme.demoSectionDescription &&
              createAnimationArr(theme.demoSectionDescription, styles.word__wrapper, 0.1, 0.01)}
          </p>

          <ul className={styles.themes__list}>
            {theme.demoList?.map((demo, i) => (
              <li key={`${demo._key}-${demo.demoName}`}>
                <DemoCard demoData={demo} index={i} theme={theme} isThemePage />
              </li>
            ))}
            <DemoBanner theme={theme} />
          </ul>
        </Wrapper>
      </section>
      <SearchInHero />
      <SubscribeSection themeSlug={theme.slug} colorScheme={'dark'} />
      <UniqueSection />
      <CtaBanner theme={theme} />
      <NavSection />
      <SearchSection theme={theme} />
      <SaleSection />
      <ProductPage theme={theme} />
      <CatalogSection />
      <OtherSection theme={theme} />
      <BlogSection />
      <HelpSection themeSlug={theme.slug} documentationLink={theme.documentationLink} />
      <SubscribeSection
        className={styles.subscribeSection}
        themeSlug={theme.slug}
        colorScheme={'grey'}
      />
    </>
  );
};

export default ThemeStockist;
